import { Injectable } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AUDIT_DIFF_MODAL, DYNAMIC_FORM, FORM_HISTORY_MODAL, FormSetup, AuditMode } from '@wdx/shared/utils';
import { ModalManagementService } from './modal-management.service';
import { QuickCreateModalComponent } from './quick-create-modal/quick-create-modal.component';

@Injectable()
export class DynamicFormsManagementService {
    constructor(private modalManagementService: ModalManagementService) {}

    openDynamicFormModal(formSetup: FormSetup): NgbModalRef | undefined {
        if (!formSetup.preserveActiveModal) {
            this.modalManagementService.closeActiveModal();
        }

        if (formSetup.isQuickCreate) {
            this.openQuickCreateModal(formSetup);
            return;
        }

        if (formSetup.auditMode === AuditMode.DiffOnly) {
            return this.modalManagementService.openModalWithId(
                FORM_HISTORY_MODAL,
                {
                    formId: formSetup.formId,
                    entityId: formSetup.entityId,
                },
            );
        }

        if (formSetup.auditMode === AuditMode.Full) {
            return this.modalManagementService.openModalWithId(
                AUDIT_DIFF_MODAL,
                {
                    auditEventId: formSetup.entityId,
                },
            );
        }

        return this.modalManagementService.openModalWithId(
            DYNAMIC_FORM,
            formSetup,
        );
    }

    openQuickCreateModal(formSetup: FormSetup) {
        const quickCreateModal =
            this.modalManagementService.openModalWithComponent(
                QuickCreateModalComponent
            );
        quickCreateModal.componentInstance.formId = formSetup.formId;
        quickCreateModal.componentInstance.entityId = formSetup.entityId;
        quickCreateModal.componentInstance.initialisationParams =
            formSetup.initialisationParams;
        quickCreateModal.componentInstance.createSuccess.subscribe(() =>
            quickCreateModal.close()
        );
    }
}
